module.exports = __webpack_public_path__ + "img/masks/01.svg";